import styled from '@emotion/styled';

export const ChartSkeletonWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
